// src/pages/Admin/GruposAdminPage.jsx
import GruposAdmin from "../../../components/GruposAdmin/index";

export default function GruposOfertas() {
    return <GruposAdmin tipo="ofertas" titulo="Controle de Acessos - Grupos de Ofertas" />;
}

export function GruposShopee() {
    return <GruposAdmin tipo="shopee" titulo="Controle de Acessos - Grupos da Shopee" />;
}
